var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{class:_vm.lineClass,attrs:{"x1":_vm.p1.x,"y1":_vm.p1.y,"x2":_vm.p2.x,"y2":_vm.p2.y}})}
var staticRenderFns = []

export { render, staticRenderFns }